import { render, staticRenderFns } from "./ImportCSVContactPage.vue?vue&type=template&id=bfcea4a6&scoped=true&"
import script from "./ImportCSVContactPage.vue?vue&type=script&lang=js&"
export * from "./ImportCSVContactPage.vue?vue&type=script&lang=js&"
import style0 from "./ImportCSVContactPage.vue?vue&type=style&index=0&id=bfcea4a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfcea4a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/bikrampahi/Projects/upwork/5 Brian/sndle.io/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VCheckbox,VDataTable,VFlex,VIcon,VLayout,VProgressLinear,VSelect,VSpacer,VToolbar,VToolbarTitle})
